import "../catalog_css/catalog.scss";
import "regenerator-runtime/runtime";
import objectFitImages from "object-fit-images";
import "svgxuse";
import autoComplete from "@tarekraafat/autocomplete.js/dist/js/autoComplete";
import Alpine from "alpinejs";
import { instanciateTemplate } from "../app_js/framework/utils";

/* global CUSTOM_COLOR, TEXT_ON_BRAND_COLOR, SECONDARY_BRAND_COLOR, DARK_BRAND_COLOR, PROGRAMS */

window.Alpine = Alpine;
Alpine.start();

let hCaptchas = {}; // Stores the hCaptchas

function browserCanUseCssVariables() {
  return window.CSS && CSS.supports("color", "var(--fake-var)");
}

if (!Int32Array.prototype.fill) {
  Int32Array.prototype.fill = Array.prototype.fill;
}

document.addEventListener("DOMContentLoaded", function () {
  if (!browserCanUseCssVariables()) {
    // well setCustomColor is more about brand color
    setCustomColor(CUSTOM_COLOR);
    ie11_set_style_on_classes("color", TEXT_ON_BRAND_COLOR, [".text-on-brand-color"]);
    ie11_set_style_on_classes("color", SECONDARY_BRAND_COLOR, [".secondary-brand-color"]);
    ie11_set_style_on_classes("color", DARK_BRAND_COLOR, [".dark-brand-color"]);
  }

  objectFitImages(".program__image");

  const searchInput = () => document.querySelector("#search-input");

  if (searchInput) {
    new autoComplete({
      data: {
        src: PROGRAMS,
        key: ["name"],
        cache: true,
      },
      selector: searchInput,
      placeHolder: "",
      threshold: 0,
      debounce: 300,
      highlight: true,
      maxResults: 10,
      searchEngine: "strict",
      resultsList: {
        render: true,
        container: (source) => {
          source.setAttribute("id", "search-results");
          source.setAttribute("class", "search-results");
        },
        destination: document.querySelector("#search .no-results"),
        position: "afterend",
        element: "ul",
      },
      resultItem: {
        content(data, source) {
          const {
            value: { category_order, category_slug, id, slug, subtitle },
            match,
          } = data;

          const href = `/${category_order}/${category_slug}/${id}/${slug}`;

          instanciateTemplate("#search-result-template", source, (instance) => {
            instance.querySelector(".js-program-button").href = href;
            instance.querySelector(".js-program-link").href = href;

            // innerHTML tolerated ONLY because we proactively escape the data in
            // CatalogHTML.programs_to_structs/1
            instance.querySelector(".js-program-link").innerHTML = match;

            if (subtitle) {
              // innerHTML tolerated ONLY because we proactively escape the data in
              // CatalogHTML.programs_to_structs/1
              instance.querySelector(".js-program-subtitle").innerHTML = subtitle;
            } else {
              instance.querySelector(".js-program-subtitle").remove();
            }
          });
        },
      },
    });

    document.addEventListener(
      "autoComplete",
      (event) => {
        const search = document.querySelector("#search");
        const main = document.querySelector("main");
        const noResults = search.querySelector(".no-results");

        if (event.detail.query.length) {
          main.classList.add("hide");
          search.classList.add("-active");
        } else {
          search.classList.remove("-active");
          main.classList.remove("hide");
        }

        if (event.detail.matches > 0) {
          noResults.classList.add("hide");
        } else {
          noResults.classList.remove("hide");
        }
      },
      false
    );
  }

  const menuToggler = document.querySelector("#menu-toggler");

  if (menuToggler) {
    menuToggler.addEventListener("click", function () {
      document.querySelector(".menu").classList.toggle("menu-visible");
      document.querySelector(".main").classList.toggle("main-menu-visible");
      document.querySelector("body").classList.toggle("body-menu-visible");
    });
  }

  const traineeRadio = document.querySelector("#trainee");
  const companyRadio = document.querySelector("#company");

  if (traineeRadio && companyRadio) {
    setRegistrationMode(traineeRadio.checked ? "trainee" : "company");
    traineeRadio.addEventListener("change", () => setRegistrationMode("trainee"));
    companyRadio.addEventListener("change", () => setRegistrationMode("company"));
  }

  const allStepsToggler = document.querySelector("#all-steps-toggler");
  const steps = document.querySelectorAll(".step");

  if (allStepsToggler) {
    allStepsToggler.addEventListener("click", onToggleAllElements);
  }

  steps.forEach(function (step) {
    step.addEventListener("click", onToggleElement);
  });

  const registrationTypesBtn = document.querySelectorAll(".registration-type-btn");

  if (registrationTypesBtn.length == 2) {
    const interBtn = document.querySelector("#registration-type-inter");
    const intraBtn = document.querySelector("#registration-type-intra");

    if (interBtn.classList.contains("-active")) {
      intraBtn.classList.remove("-active");
    } else if (intraBtn.classList.contains("-active")) {
      interBtn.classList.remove("-active");
    } else {
      interBtn.classList.add("-active");
    }

    interBtn.addEventListener("click", function () {
      intraBtn.classList.remove("-active");
      interBtn.classList.add("-active");

      const dateComponents = document.querySelectorAll(".registration-date");
      for (let dateComponent of dateComponents) {
        dateComponent.querySelector("select").disabled = false;
        dateComponent.classList.remove("hide");
      }
    });
    intraBtn.addEventListener("click", function () {
      interBtn.classList.remove("-active");
      intraBtn.classList.add("-active");

      const dateComponents = document.querySelectorAll(".registration-date");
      for (let dateComponent of dateComponents) {
        dateComponent.querySelector("select").disabled = true;
        dateComponent.classList.add("hide");
      }
    });
  }

  const dateComponents = document.querySelectorAll(".registration-date");
  if (dateComponents.length == 2) {
    dateComponents.forEach((dateComponent) => dateComponent.addEventListener("input", copySelectedDate));
  }

  const traineeForm = document.querySelector("#trainee-form");
  const companyForm = document.querySelector("#company-form");
  const forms = [traineeForm, companyForm];

  forms.forEach(setupValidation);
  forms.forEach(bindSubmitButton);

  createHCaptchas();

  document.querySelectorAll(".no_picture").forEach((img) => {
    const rotation = Math.floor(img.getAttribute("data-program-id") % 360);
    img.style = `filter: hue-rotate(${rotation}deg);`;
  });

  document.querySelectorAll("[data-video-id]").forEach((container) => {
    container.addEventListener(
      "click",
      (event) => {
        const target = event.target.closest(".play-button-container");
        const iframe_url = "//www.youtube.com/embed/" + target.dataset.videoId + "?autoplay=1&autohide=1";

        const iframe = document.createElement("iframe");
        iframe.allowFullscreen = "allowfullscreen";
        iframe.frameborder = "0";
        iframe.src = iframe_url;
        iframe.width = "100%";
        iframe.classList.add("video-iframe");

        target.classList.remove("play");
        target.appendChild(iframe);
      },
      false
    );
  });

  const programs = document.querySelectorAll(".program");
  const trainingPedagogicalModalityFilter = document.querySelector("#training-pedagogical-modality-filter");
  const certifyingFilter = document.querySelector("#certifying-filter");
  const cpfOrFundingFilter = document.querySelector("#js-cpf-or-funding-filter");

  const programsFilter = () => {
    const selectedModality = trainingPedagogicalModalityFilter.value;
    const selectedCertifying = certifyingFilter.value;
    // international catalog don't have cpf or funding field
    const selectedCpfOrFunding = cpfOrFundingFilter ? cpfOrFundingFilter.value : "any";

    programs.forEach((program) => {
      const modality = program.dataset.trainingPedagogicalModality;
      const certifying = program.dataset.certifying != undefined;
      const cpfOrFunding = program.dataset.cpf != undefined || program.dataset.funding != undefined;

      if (
        (selectedModality === "any" || selectedModality == modality) &&
        (selectedCertifying === "any" || selectedCertifying == certifying) &&
        (selectedCpfOrFunding === "any" || selectedCpfOrFunding == cpfOrFunding)
      ) {
        program.classList.remove("hide");
      } else {
        program.classList.add("hide");
      }
    });
  };

  if (trainingPedagogicalModalityFilter) {
    trainingPedagogicalModalityFilter.addEventListener("change", () => programsFilter());
  }

  if (certifyingFilter) {
    certifyingFilter.addEventListener("change", () => programsFilter());
  }

  if (cpfOrFundingFilter) {
    cpfOrFundingFilter.addEventListener("change", () => programsFilter());
  }
});

function createHCaptchas() {
  if (!window.hcaptcha) {
    setTimeout(createHCaptchas, 500);
  } else {
    document.querySelectorAll(".js-h-captcha-spot").forEach(function (div) {
      const siteKey = div.getAttribute("data-sitekey");
      const callback = div.getAttribute("data-callback");
      const size = div.getAttribute("data-size");
      const formId = div.getAttribute("data-form-id");

      let widgetID = window.hcaptcha.render(`hcaptcha-${formId}`, { sitekey: siteKey, callback: callback, size: size });
      hCaptchas[formId] = widgetID;
    });
  }
}

function bindSubmitButton(form) {
  if (!form) {
    return;
  }

  const button = form.querySelector("button[type='submit']");

  button.addEventListener(
    "click",
    (event) => {
      event.preventDefault();
      validateForm(form);

      let hCaptchaWidgetID = hCaptchas[form.id];
      // IE does not support this API, in this case directly call hcaptcha
      if (form.reportValidity) {
        if (form.reportValidity()) {
          window.hcaptcha.execute(hCaptchaWidgetID);
        }
      } else {
        window.hcaptcha.execute(hCaptchaWidgetID);
      }
    },
    false
  );
}

function validateForm(form) {
  const inputs = form.getElementsByTagName("input");
  const textareaInputs = form.getElementsByTagName("textarea");

  trimFormFields(inputs, textareaInputs); // So that a field filled with spaces is not considered valid if required
  invalidateInvalidDates(inputs); // A date with a year over 9999 produces an invalid changeset in backend
}

function trimFormFields(inputs, textareaInputs) {
  for (const input of inputs) {
    if (input.type !== "hidden") {
      input.value = input.value.trim();
    }
  }

  for (const textarea of textareaInputs) {
    textarea.value = textarea.value.trim();
  }
}

function invalidateInvalidDates(inputs) {
  for (const input of inputs) {
    if (input.type === "date") {
      const year = input.value.split("-")[0];
      if (year.length > 4) {
        input.setCustomValidity("L'année est trop grande");
      } else {
        input.setCustomValidity("");
      }
    }
  }
}

function copySelectedDate(event) {
  const hiddenDateComponent = document.querySelector("form.hide > .registration-date");
  const select = hiddenDateComponent.querySelector("select");
  select.selectedIndex = event.target.selectedIndex;
}

function setupValidation(form) {
  if (!form) {
    return;
  }

  const inputs = form.querySelectorAll("input, select, textarea");

  for (let input of inputs) {
    input.addEventListener(
      "invalid",
      () => {
        input.classList.add("error");
      },
      false
    );

    input.addEventListener("blur", () => {
      input.checkValidity();
    });
  }
}

function onToggleElement(event) {
  event.target.closest(".step").classList.toggle("-opened");
}

function onToggleAllElements() {
  const allStepsToggler = document.querySelector("#all-steps-toggler");

  allStepsToggler.classList.toggle("-opened");

  const steps = document.querySelectorAll(".step");

  let opened = allStepsToggler.classList.contains("-opened");

  steps.forEach((step) => {
    if (opened) {
      step.classList.add("-opened");
    } else {
      step.classList.remove("-opened");
    }
  });
}

function setRegistrationMode(mode) {
  if (mode === "company") {
    document.querySelector(".trainee-form").classList.add("hide");
    document.querySelector(".company-form").classList.remove("hide");
  } else {
    document.querySelector(".trainee-form").classList.remove("hide");
    document.querySelector(".company-form").classList.add("hide");
  }
}

function setCustomColor(color) {
  [".header", ".footer", ".menu", ".-primary", ".dropdown-active", ".category .icon", ".category-resources .icon"].forEach(
    (className) => {
      const elements = document.querySelectorAll(className);

      elements.forEach(function (element) {
        if (element) {
          if (element.tagName != "svg" && !element.style["background-color"]) {
            element.style["background-color"] = color;
          } else if (!element.style["fill"]) {
            element.style["fill"] = color;
          }
        }
      });
    }
  );
}

// from style color
// ex: ie11_set_text_on_classes("color", TEXT_ON_BRAND_COLOR, [".text-on_brand-color"])
function ie11_set_style_on_classes(styleKey, color, classNames) {
  classNames.forEach((className) => {
    const elements = document.querySelectorAll(className);

    elements.forEach(function (element) {
      if (element) {
        element.style[styleKey] = color;
      }
    });
  });
}

const submit = (selector) => {
  const form = document.querySelector(selector);
  return form.submit();
};

window.onRegistrationCompanySubmit = () => submit("#company-form");
window.onRegistrationTraineeSubmit = () => submit("#trainee-form");

// Transition for category nav in header
const toggles = document.querySelectorAll("#category-toggle");

for (let toggle of toggles) {
  toggle.addEventListener("click", () => {
    const category = document.querySelector("#categories");
    if (category) {
      if (category.style.maxHeight == "0px" || !category.style.maxHeight) {
        category.style.maxHeight = "fit-content";
      } else {
        category.style.maxHeight = "0px";
      }
    }
  });
}
